import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import SpriteAnimator from "./gamePlay/SpriteAnimator";
import InfinityCard from "../components/InfinityCard";
import NeoButton from "./NeoButton";


const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
    },
    content: {
        position: "relative",
        background: "#1b1b1b",
        borderRadius: "8px",
        padding: "20px",
        textAlign: "center",
        width: "280px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    },
    sparkleContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 1,
    },
    closeButton: {
        marginTop: "16px",
    },
};

const CraftedCardModal = ({ visible, onClose, craftedCard }) => {
    return (
        <Modal open={visible} onClose={onClose} closeAfterTransition>
            <AnimatePresence>
                {visible && (
                    <motion.div
                        style={modalStyles.overlay}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            style={modalStyles.content}
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            transition={{ type: "spring", damping: 12 }}
                        >
                            <Box sx={{ position: "relative", mb: 2 }}>
                                {/* Sparkle effect overlay */}
                                <Box sx={modalStyles.sparkleContainer}>
                                    <SpriteAnimator
                                        animationName="shinefx"
                                        frameHeight={64}
                                        frameCount={12}
                                        fps={16}
                                        delay={0}
                                        loop={true}
                                        style={{ width: 64, height: 64, margin: "0 auto" }}
                                    />
                                </Box>
                                {/* Display the crafted card */}
                                {craftedCard ? (
                                    <InfinityCard
                                        {...craftedCard}
                                        heightPer={100}
                                        containerHeight={220}
                                        borderPx={4}
                                        shineEffect={true}
                                        showAmtOwned={false}
                                    />
                                ) : (
                                    <Typography variant="h6" sx={{ color: "#fff" }}>
                                        No Card
                                    </Typography>
                                )}
                            </Box>
                            <Typography variant="h6" sx={{ color: "#fff", mb: 2 }}>
                                Card Crafted!
                            </Typography>
                            <NeoButton
                                text="Close"
                                color="$primary"
                                width={50}
                                onClick={onClose}
                                sx={modalStyles.closeButton}
                            />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </Modal>
    );
};

export default CraftedCardModal;
